const TYPES = {
    UPDATE_STATUS: 'UPDATE_STATUS'
};

export default {
    TYPES,

    updateStatus: payload => {
        return {
            type: TYPES.UPDATE_STATUS,
            payload
        };
    }
};
